import * as Yup from "yup";

export const clientLeadsSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  company: Yup.string().required("Company Name is required"),
  phone: Yup.string().required("Phone is required"),
  service_name: Yup.string().required("Service Name is required"),
  requirements: Yup.string().required("Requirements are required"),
  status: Yup.string()
    .oneOf([
      "Not received",
      "Busy",
      "Sent demo",
      "Sent proposal",
      "Wanna visit office",
      "Wanna zoom meeting",
      "Sent proposal but no response",
      "Sent demo, he will review and back to us",
      "Knocked by mistake",
      "He has low budget",
      "He will knock us when he need",
    ])
    .required("Status is required"),
  start_date: Yup.date().required("Start Date is required"),
});

